import * as lib from '~/dependencies';
import { colors } from '~/layout';

type WrapperProps = {
  disabled: boolean;
};

type DividerProps = {
  backgroundColor: string;
};

type DropdownArrowProps = {
  open: boolean;
};

export const Wrapper = lib.styled.div<WrapperProps>`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  height: 34px;
  border-radius: 10px;
  overflow: visible;
  background-color: ${({ disabled }: WrapperProps) =>
    disabled ? colors.lightBlue18 : colors.green09};
  transition: background-color 0.2s ease;
  flex-shrink: 0;
`;

export const SendAction = lib.styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  padding: 0 10px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: ${colors.white};
  font-family: Nunito;
  font-size: 13px;
  font-weight: 700;
  border-radius: 10px 0 0 10px;
  // opacity: ${({ disabled }: WrapperProps) => (disabled ? 0.8 : 1)};

  &:disabled {
    cursor: not-allowed;
  }
`;

export const ChannelIcon = lib.styled(lib.ReactSVG)`
  display: flex;
  align-items: center;

  svg {
    width: 16px;
    height: 16px;
    display: block;
    overflow: visible;
    stroke: ${colors.white};
    stroke-width: 0.7px;
    stroke-linecap: round;
    stroke-linejoin: round;

    ${({ disabled }: WrapperProps) =>
      disabled &&
      `
      path:nth-of-type(1) {
        fill: ${colors.white};
      }

      path:nth-of-type(2) {
        fill: ${colors.lightBlue18};
      }
    `}
`;

export const Divider = lib.styled.div<DividerProps>`
  width: 1px;
  margin: 6px 0;
  background-color: rgba(255, 255, 255, 0.4);
  flex-shrink: 0;
`;

export const DropdownTrigger = lib.styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  background: ${colors.green09};
  border: none;
  cursor: pointer;
  border-radius: 0 10px 10px 0;

  &:disabled {
    cursor: not-allowed;
    background: ${colors.lightBlue18};
  }
`;

export const DropdownArrow = lib.styled(lib.ReactSVG)<DropdownArrowProps>`
  display: flex;
  align-items: center;
  transition: transform 0.2s ease;
  transform: ${({ open }: DropdownArrowProps) =>
    open ? 'rotate(0deg)' : 'rotate(180deg)'};

  svg {
    width: 10px;
    height: 10px;
    display: block;
  }

  path {
    fill: ${colors.white};
  }
`;

export const DropdownMenu = lib.styled.ul`
  position: absolute;
  bottom: calc(100% + 6px);
  right: 0;
  background-color: ${colors.white};
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  list-style: none;
  margin: 0;
  padding: 4px;
  z-index: 200;
  min-width: 130px;
`;

export const DropdownItem = lib.styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  border-radius: 6px;
  font-family: Nunito;
  font-size: 13px;
  color: ${colors.darkGray11};
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background-color: ${colors.lightGray};
  }
`;

type DropdownItemIconProps = {
  iconColor: string;
};

export const DropdownItemIcon = lib.styled(lib.ReactSVG)<DropdownItemIconProps>`
  display: flex;
  align-items: center;

  svg {
    width: 15px;
    height: 15px;
    display: block;
  }

  path, circle {
    fill: ${({ iconColor }: DropdownItemIconProps) => iconColor};
  }
`;
